import axios from 'axios';
import index from './index';

export default {
    getData() {
        return axios.get(`/modules/${index.api}`)
    },
};